import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "layer-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args))),
      class: "next-layer-btn"
    }, [
      (_ctx.icon.startsWith('mdi-home'))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(['mdi', _ctx.icon])
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.nextLabel), 1),
      (!_ctx.icon.startsWith('mdi-home'))
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(['mdi', _ctx.icon])
          }, null, 2))
        : _createCommentVNode("", true)
    ])
  ]))
}